import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Logo } from '../SiteHeader/components/NavLogo';


class SiteHeaderFocus extends Component {
  static getDomId() {
    return 'layout_site_header_focus';
  }

  static getComponentData() {
    return {
      homeURL: window.seMarketplace.site_globals.homeURL,
      disableLogo: window.seMarketplace.site_globals.disableLogo,
      ...window.seMarketplace[this.getDomId()],
    };
  }

  render() {
    const {
      logo,
      siteName,
      homeURL,
      disableLogo
    } = this.props;

    const title = `${siteName} Homepage`

    return (
      <div className="site-header">
        <div className="site-header__utility-wrapper">
          <div className="site-header__utility">
            <div className="site-header__branding">
            {disableLogo ? <Logo logo={logo} logoAltText={title} /> :
              <a href={homeURL} title={title}>
                <Logo logo={logo} logoAltText={title} />
              </a>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SiteHeaderFocus.propTypes = {
  logo: PropTypes.string.isRequired,
  siteName: PropTypes.string.isRequired,
  homeURL: PropTypes.string.isRequired,
  disableLogo: PropTypes.bool.isRequired
};

export default SiteHeaderFocus;
